export const ADMIN_TOKEN_REQUIRED_BANNER = 'admin-token-required-banner'
export const MEMBER_TOKEN_REQUIRED_BANNER = 'member-token-required-banner'
export const ADMIN_TOKEN_NOT_REQUIRED_BANNER = 'admin-token-not-required-banner'
export const MEMBER_TOKEN_NOT_REQUIRED_BANNER =
  'member-token-not-required-banner'
